import { documentationActions } from '../../actions/constant';

const {
  SUCCESS_GET_ALL_MISCELLANEOUS_DOCUMENTS,
  FAILURE_GET_ALL_MISCELLANEOUS_DOCUMENTS,
  LOADING_GET_ALL_MISCELLANEOUS_DOCUMENTS,
} = documentationActions;

const intitialstate: object = {
  response: null,
  areGettingDocuments: false,
  loading: false,
};

export const getAllMiscellaneousDocumentsReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case SUCCESS_GET_ALL_MISCELLANEOUS_DOCUMENTS: {
      return {
        ...state,
        areGettingDocuments: true,
        response: action.payload?.data,
        loading: false,
      };
    }

    case FAILURE_GET_ALL_MISCELLANEOUS_DOCUMENTS:
      return {
        ...state,
        areGettingDocuments: false,
        response: action.payload,
        loading: true,
      };

    case LOADING_GET_ALL_MISCELLANEOUS_DOCUMENTS:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};
